import React, { useState, useEffect, useRef, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Box, Container, Typography } from '@material-ui/core'

// API
import { putPublicAPI } from '../api'

// components
import Loader from '../components/utils/Loader'

import { ToastContext } from '../contexts/Toast'

const EmailConfirmation = () => {
   let mounted = useRef(true)

   const navigate = useNavigate()
   const { token0, token1, token2 } = useParams()
   const { setToasts } = useContext(ToastContext)

   const [loading, setLoading] = useState(true)
   const [message, setMessage] = useState({ type: '', info: '' })

   useEffect(() => {
      setTimeout(() => {
         if (!token0) navigate('/404')
         mounted.current && setLoading(false)
      }, 1000)

      const prepareEmailConfirmation = async () => {
         let confirmEmail = await putPublicAPI('/confirm-email', {
            token: token0 + '.' + token1 + '.' + token2
         })

         if (mounted.current) {
            if (confirmEmail?.success) {
               setMessage({ type: 'success', info: confirmEmail?.data[0].msg })
               setToasts({
                  type: 'success',
                  messages: confirmEmail?.data
               })
            } else {
               setMessage({ type: 'error', info: confirmEmail?.errors[0].msg })
               setToasts({
                  type: 'error',
                  messages: confirmEmail?.errors
               })
            }
         }
      }

      prepareEmailConfirmation()

      return () => (mounted.current = false)
   }, [token0, token1, token2, navigate, setToasts])

   let color = message.type === 'error' ? '#d22f25' : 'green'
   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : `Confirm email | The HosePod`}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               ) : (
                  <Box sx={{ textAlign: 'center', mt: '30vh' }}>
                     <Typography sx={{ fontSize: '30px', color, fontWeight: 500 }}>
                        {message.info}
                     </Typography>
                  </Box>
               )}
            </Container>
         </Box>
      </>
   )
}

export default EmailConfirmation
